module.exports = __webpack_public_path__ + "static/Cafe24Danjunghae.subset-16b7102baf5d6051cf54f604ff97abf5.woff";